import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { homeResearchPoints } from '../../data/home';
import { fadeUp } from '../../utils/motion';
export function HomeResearch() {
  return <section aria-labelledby="home-research-title" className="bg-surface-bg border-b border-line py-20 lg:py-24" data-id="element-1151" data-mp="317d9eyfd7m5p">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16" data-id="element-1152" data-mp="2wea987g31egj">
        <div className="lg:col-span-5" data-id="element-1153" data-mp="365oiv81qzune">
          <p className="text-sm font-medium text-teal mb-3" data-id="element-1154" data-mp="364mvc43jpfos">Research</p>
          <h2 id="home-research-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1155" data-mp="3k57cywxq55gp">
            The work behind the methods and systems
          </h2>
        </div>
        <div className="lg:col-span-7 lg:pt-8" data-id="element-1156" data-mp="1pqmzb47tma6t">
          <p className="text-lg text-ink-dark leading-relaxed" data-id="element-1157" data-mp="1ptiwurfrawuq">
            Explore the methods, questions and studies shaping SyNeural’s knowledge systems, assessment models and
            development programs.
          </p>
          <ul className="mt-6 border-t border-line" data-id="element-1158" data-mp="26ombhj3wnvgh">
            {homeResearchPoints.map(point => <li key={point} className="border-b border-line py-3 text-ink-muted" data-id="element-1159" data-mp="2apxtp3kg9een">
                {point}
              </li>)}
          </ul>
          <a href="/research" className="mt-6 inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1160" data-mp="2fih7o1n1ubjz">
            Explore our research <ArrowRight size={16} aria-hidden="true" data-id="element-1161" data-mp="2uegllswub5x1" />
          </a>
        </div>
      </motion.div>
    </section>;
}